import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {setPassword} from '../../actions/Auth/AuthActions';
import {renderTextInputField,
    renderPasswordInputField,
    renderEmailInputField} from '../Layout/FormInputs'
import {toastr} from "react-redux-toastr";
import {langs} from '../../config/localization';
import {Loader} from "../Common/Loader";
import {required} from '../../validation';
import queryString from 'query-string';
import {focusOnError} from "../../utils";

class ResetPassword extends Component {

    /**
     * Class constructor
     * @param props
     */
    constructor (props) {
        super(props);

        //Keep values in state
        this.state = {
            fullname    : this.props.initialValues.name,
            email       : this.props.initialValues.email,
            showLoader  : false
        };

        //Bind the event handlers
        this.handleNameChange   = this.handleNameChange.bind(this);
        this.handleEmailChange  = this.handleEmailChange.bind(this);
    }

    componentWillMount(){
        let params =  queryString.parse(this.props.location.search);       
        if(params.uid !== undefined && params.uid !== '' && params.token !== undefined && params.token !==''){
            
            this.setState({
                user_id: params.uid,
                token: params.token
            });
        }else{
            toastr.error(langs.error, langs.messages.token_expired);
            setTimeout(function() {
                window.location.assign('/signup');
            }.bind(this), 3000);
        }
    }

    /**
     * Submit signup form
     * @param values
     */
    onSubmit = (values) => {
    this.setState({showLoader : true});
    let finaldate={
            user_id: this.state.user_id,
            password: values.password,
            token: this.state.token
        };

        //Call the register user action
        this.props.setPassword(finaldate, (response)=>{
            this.setState({showLoader : false});
            //this.setState({showLoader : false});
            if(response.status === 200){
                toastr.success(langs.success, langs.messages.reset_password_success);

                //Delay the page redirection for 1 second to show toastr message
                setTimeout(function() {
                    window.location.assign('/login');
                }.bind(this), 3000);
            }else {
                if(response.status == 400) {
                    toastr.error(langs.error, langs.messages.invalid_user_or_token);
                } else if (response.status == 422){
                    toastr.error(langs.error, langs.messages.token_expired);
                }else {
                    toastr.error(langs.error, langs.messages.default_error);
                }
                setTimeout(function() {
                    window.location.assign('/login');
                }.bind(this), 3000);
            }
        });
    }

    /**
     * Handle name change
     * @param e
     */
    handleNameChange(e) {
        this.setState({
            fullname: e.target.value
        });
    }

    /**
     * Handle email change
     * @param e
     */
    handleEmailChange(e) {
        this.setState({
            email: e.target.value
        });
    }

    renderPasswordField() {
        return (
            <Field
                name="password"
                label={langs.password}
                component={renderPasswordInputField}
            />
        );
    }

    renderConfirmPasswordField() {
        return (
            <Field
                name="confirm_password"
                label={langs.confirm_password}
                component={renderPasswordInputField}
            />
        );
    }

    /**
     * Render signup form
     * @returns {*}
     */
    render(){
        const {handleSubmit} = this.props;
        const TopSliderSettings = {
            arrows: true,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe:false,
            autoplay: false,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    arrows: true,
                }
            },

        ]
        };
        if(!this.state.showLoader) {
            return (

                <section className="section-login">
                    <form noValidate className="serPasswordform" onSubmit={handleSubmit(this.onSubmit)}>
                        <div className="row">
                            <div className="medium-12 columns">
                                <div className="login-wrapper">
                                    <div className="login-container">
                                        <div className="login-left primary-gradient-bg">
                                            <div className="globe-bg">
                                                <h2>Welcome to earthDECKS</h2>
                                            </div>
                                        </div>
                                        <div className="login-right">
                                            <h1>Reset Password</h1>
                                            <div className="icon-form text-center">
                                                <img src="/assets/images/eathdeck/set_password_icon.png" />
                                            </div>
                                            <div className="login-form">
                                                <div className="form-group password">
                                                    <label>Password*</label>
                                                    <Field
                                                        name="password"
                                                        type="password"
                                                        component={renderPasswordInputField}
                                                        validate={[required]}
                                                        maxLength="30" 
                                                        className=""                       
                                                    />                                               

                                                </div>
                                                <div className="form-group password">
                                                    <label>Confirm Password*</label>
                                                    <Field
                                                        name="confirmPassword"
                                                        type="password"
                                                        component={renderPasswordInputField}
                                                        validate={[required]}
                                                        maxLength="30"
                                                        className=""                        
                                                    />                                              

                                                </div>
                                                <div className="form-group text-center">
                                                    <button type="submit" className="btn-primary primary-gradient-bg">
                                                        <span>RESET PASSWORD</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>

            );
        } else {
            return <Loader loaderContent='form-submission' />
        }
    }
}

/**
 * Form validation
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};
    if(!values.password){
        errors.password = langs.validation_messages.password_required;
    }

    if(values.password && (values.password.length < 4 || values.password.length > 32)){
        errors.password = langs.validation_messages.password_length;
    }

    if(!values.confirmPassword){
        errors.confirmPassword = langs.validation_messages.confirm_password_required;
    }

    if(values.password && values.confirmPassword && values.password !== values.confirmPassword){
        errors.confirmPassword = langs.validation_messages.password_confirm_password;
    }

    return errors;
}

const mapStateToProps = ({auth}) => {
    const {fullname, email, facebookAccessToken, googleAccessToken} = auth;

    //Keep values in initial values object to be passed on form submit
    return  {
        initialValues : {
            name                        : fullname,
            email                       : email,
            facebookAccessTokenInternal : facebookAccessToken,
            googleAccessTokenInternal   : googleAccessToken
        }
    };
};

//Connect action to component
export default connect(mapStateToProps,
    {setPassword}
)(reduxForm({
    form: 'serPasswordform',
    validate: validate,
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(ResetPassword));



// WEBPACK FOOTER //
// ./components/Auth/ResetPassword.js